const QUOTE_EDIT_STORAGE_KEY = 'ingaz-quote-edit';

export function readEditingQuote() {
  try {
    const item = JSON.parse(sessionStorage.getItem(QUOTE_EDIT_STORAGE_KEY) || 'null');
    return item && typeof item === 'object' ? item : null;
  } catch {
    return null;
  }
}

export function saveEditingQuote(item) {
  try {
    sessionStorage.setItem(QUOTE_EDIT_STORAGE_KEY, JSON.stringify(item));
  } catch {
    // Editing still works in memory when browser storage is unavailable.
  }
}

export function clearEditingQuote() {
  try {
    sessionStorage.removeItem(QUOTE_EDIT_STORAGE_KEY);
  } catch {
    // Nothing else is required when browser storage is unavailable.
  }
}

export function editingQuotePath(item) {
  return item?.pathname || item?.specifications?.source_path || '';
}
